import React, { useState } from 'react';
import { FaRegUserCircle } from 'react-icons/fa';
import { useDispatch, useSelector } from 'react-redux';
import Axios from '../Utils/axios';
import SummaryAPI from '../Commson/summaryApi';
import { AxiosToastError } from '../Utils/AxiosToastError';
import { updateAvatar } from "../Store/Userslice";
import { IoClose } from 'react-icons/io5';

const UserProfileAvatar = ({ close }) => {
  const user = useSelector(state => state.user);
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [preview, setPreview] = useState(null); // preview before upload

  const handleUploadAvatarImage = async (e) => {
    const file = e.target?.files?.[0];
    if (!file) return;

    // preview selected image
    setPreview(URL.createObjectURL(file));

    const formData = new FormData();
    formData.append('avatar', file);

    try {
      setLoading(true);
      const response = await Axios({
        ...SummaryAPI.uploadAvatar,
        data: formData,
      });

      const { data: responseData } = response;
      dispatch(updateAvatar(responseData.data));
      close(); // close modal after success
    } catch (error) {
      AxiosToastError(error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="fixed inset-0 bg-black bg-opacity-60 flex items-center justify-center z-50">
      <div className="bg-white w-full max-w-sm rounded-2xl shadow-lg p-6 relative animate-fadeIn">
        
        {/* Close button */}
        <button
          onClick={close}
          className="absolute top-3 right-3 text-gray-500 hover:text-gray-700 transition"
        >
          <IoClose size={22} />
        </button>

        {/* Avatar Preview */}
        <div className="flex flex-col items-center">
          <div className="w-24 h-24 bg-gray-200 flex items-center justify-center rounded-full overflow-hidden shadow-md">
            {preview ? (
              <img
                src={preview}
                alt="Preview"
                className="w-full h-full object-cover"
              />
            ) : user?.avatar ? (
              <img
                src={user.avatar}
                alt={user?.name || "User Avatar"}
                className="w-full h-full object-cover"
              />
            ) : (
              <FaRegUserCircle size={80} className="text-gray-400" />
            )}
          </div>

          {/* Upload button */}
          <label
            htmlFor="uploadProfile"
            className="mt-5 px-5 py-2 bg-orange-500 text-white rounded-lg cursor-pointer shadow hover:bg-orange-600 transition text-sm font-medium"
          >
            {loading ? "Uploading..." : "Change Avatar"}
          </label>
          <input
            onChange={handleUploadAvatarImage}
            type="file"
            id="uploadProfile"
            accept="image/*"
            className="hidden"
          />
        </div>
      </div>
    </section>
  );
};

export default UserProfileAvatar;
